"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPluginInView = exports.getPluginInView = void 0;
const jotai_1 = require("jotai");
const pluginInViewAtom = (0, jotai_1.atom)(false);
const getPluginInView = () => {
    var _a;
    const store = (_a = window.Jupiter) === null || _a === void 0 ? void 0 : _a.store;
    if (!store) {
        console.warn('Jupiter store is not available.');
        return false;
    }
    return store.get(pluginInViewAtom);
};
exports.getPluginInView = getPluginInView;
const setPluginInView = (value) => {
    var _a;
    const store = (_a = window.Jupiter) === null || _a === void 0 ? void 0 : _a.store;
    if (!store) {
        console.warn('Jupiter store is not available.');
        return;
    }
    store.set(pluginInViewAtom, value);
};
exports.setPluginInView = setPluginInView;
